import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getrapportspintoss } from "../Redux/Actions/RapportSpintossAction";
import CardRapportSpintoss from "./CardRapportSpintoss";
import './ListRapportsTwin.css';
import { Table, Button } from 'react-bootstrap';
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import html2canvas from "html2canvas";
import { PieChart } from '@mui/x-charts/PieChart';

function ListRapportsSpintoss() {
  const dispatch = useDispatch();
  const chartRef = useRef(null);

  useEffect(() => {
    dispatch(getrapportspintoss());
  }, [dispatch]);

  const rapports = useSelector((state) => state.RapportSpintossReducer.RapportsSpintoss) 

  const calcul = (data) => {
    return {
      totalAmount: data.reduce((acc, cur) => acc + (cur.TotalAmount || 0), 0),
      totalTpe: data.reduce((acc, cur) => acc + (cur.TotalTpe || 0), 0),
      totalDailyExpenses: data.reduce((acc, cur) => acc + (cur.DailyExpenses || 0), 0),
      resultatnet: data.reduce((acc, cur) => acc + ((cur.TotalAmount || 0) - (cur.DailyExpenses || 0)), 0),
      Espece: data.reduce((acc, cur) => acc + (cur.Espece || 0), 0),
      Reduction10: data.reduce((acc, cur) => acc + (cur.Reduction10 || 0), 0),
      Reduction20: data.reduce((acc, cur) => acc + (cur.Reduction20 || 0), 0),
      ReductionTwin: data.reduce((acc, cur) => acc + (cur.ReductionTwin || 0), 0),
      Privilege: data.reduce((acc, cur) => acc + (cur.Privilege || 0), 0),
      Glovo: data.reduce((acc, cur) => acc + (cur.Glovo || 0), 0),
      Tresto: data.reduce((acc, cur) => acc + (cur.Tresto || 0), 0),
      Tpe: data.reduce((acc, cur) => acc + (cur.Tpe || 0), 0),
      Cheque: data.reduce((acc, cur) => acc + (cur.Cheque || 0), 0),
      packAnnif: data.reduce((acc, cur) => acc + (cur.PackAnnif || 0), 0),
      taxi: data.reduce((acc, cur) => acc + (cur.TaxiExpenses || 0), 0),
      repair: data.reduce((acc, cur) => acc + (cur.RepairExpenses || 0), 0),
      advance: data.reduce((acc, cur) => acc + (cur.StaffAdvance || 0), 0),
      misc: data.reduce((acc, cur) => acc + (cur.MiscPurchases || 0), 0),
      other: data.reduce((acc, cur) => acc + (cur.OtherExpenses || 0), 0),
    };
  };

  const [somme, setSomme] = useState({
    totalAmount: 0,
    totalTpe: 0,
    totalDailyExpenses: 0,
    resultatnet: 0,
    Espece: 0,
    Reduction10: 0,
    Reduction20: 0,
    ReductionTwin: 0,
    Privilege: 0,
    Glovo: 0,
    Tresto: 0,
    Tpe: 0,
    Cheque: 0,
    packAnnif: 0,
    taxi: 0,
    repair: 0,
    advance: 0,
    misc: 0,
    other: 0,
  });

  const [localisation, setLocalisation] = useState("All");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [recherche,setRecherche] = useState(false)

  const filterData = () => {
    setRecherche(true)
    if (!Array.isArray(rapports) || rapports.length === 0) {
      setFilteredData([]);
      return;
    }

    const start = startDate ? new Date(startDate) : null;
    const end = endDate ? new Date(endDate) : null;

    const filtered = rapports.filter((entry) => {
      const entryDate = new Date(entry.DateCollect);
      const isLocationMatch = localisation === "All" || entry.localisation === localisation;
      const isDateInRange = (!start || entryDate >= start) && (!end || entryDate <= end);
      return isLocationMatch && isDateInRange;
    });
console.log(filtered)
    setFilteredData(filtered);
    setSomme(calcul(filtered));
  };

  const pieData = [
    { id: 0, value: somme.Espece, label: 'Espèces' },
    { id: 1, value: somme.Tresto, label: 'Ticket Resto' },
    { id: 2, value: somme.Glovo, label: 'Glovo' },
    { id: 3, value: somme.Tpe, label: 'TPE' },
    { id: 4, value: somme.Cheque, label: 'Chèque' },
  ].filter(item => item.value > 0);

  const pieExpensesData = [
    { id: 0, value: somme.taxi, label: 'Taxi' },
    { id: 1, value: somme.repair, label: 'Réparation' },
    { id: 2, value: somme.advance, label: 'Avance' },
    { id: 3, value: somme.misc, label: 'Achats Divers' },
    { id: 4, value: somme.other, label: 'Autres' },
  ].filter(item => item.value > 0);

  const pieGlobalData = [
    { id: 0, value: somme.resultatnet, label: 'Net', color: '#4caf50' },
    { id: 1, value: somme.totalDailyExpenses, label: 'Dépenses', color: '#f44336' },
  ].filter(item => item.value > 0);

  const downloadPDF = async () => {
    const doc = new jsPDF();
  
    // En-tête
    doc.text("Rapport de Résultats - " + localisation, 20, 15);
  
    let startY = 25;

    if (chartRef.current) {
      try {
        const canvas = await html2canvas(chartRef.current, { scale: 2 });
        const imgData = canvas.toDataURL('image/png');
        doc.addImage(imgData, 'PNG', 15, 20, 180, 90);
        startY = 115;
      } catch (err) {
        console.error("Error generating chart for PDF", err);
      }
    }
  
    const pdfBody = [
      [{ content: 'SECTION : RÉCAPITULATIF DES RECETTES', colSpan: 2, styles: { fillColor: [241, 245, 249], fontStyle: 'bold', halign: 'center' } }],
      ["Espéces", somme.Espece],
      ["Reduction 10%", somme.Reduction10],
      ["Réduction 20%", somme.Reduction20],
      ["Réduction TwinClub", somme.ReductionTwin],
      ["Privilége", somme.Privilege],
      ["Glovo", somme.Glovo],
      ["Ticket Resto", somme.Tresto],
      ["Tpe", somme.Tpe],
      ["Chèque", somme.Cheque],
      ["Pack Anniversaire", somme.packAnnif],
      ["TOTAL DES RECETTES", somme.totalAmount],
      ["Dont TPE (Total)", somme.totalTpe],
      [{ content: 'SECTION : DÉTAIL DES DÉPENSES', colSpan: 2, styles: { fillColor: [241, 245, 249], fontStyle: 'bold', halign: 'center' } }],
      ["- Taxi", somme.taxi],
      ["- Réparation", somme.repair],
      ["- Avance Personnel", somme.advance],
      ["- Achats Divers", somme.misc],
      ["- Autres", somme.other],
      ["TOTAL DES DÉPENSES", somme.totalDailyExpenses],
      [{ content: 'BILAN FINAL', colSpan: 2, styles: { fillColor: [236, 253, 245], fontStyle: 'bold', halign: 'center' } }],
      ["RÉSULTAT NET", somme.resultatnet],
    ];

    // Génération du tableau PDF
    doc.autoTable({
      startY: startY,
      head: [["Catégorie", "Valeur (TND)"]],
      body: pdfBody,
      styles: { fontSize: 9, cellPadding: 4 },
      headStyles: { fillColor: [26, 32, 44], textColor: [255, 255, 255], fontStyle: 'bold' },
      alternateRowStyles: { fillColor: [252, 253, 254] },
      didParseCell: function(data) {
        const rowText = data.row.cells[0]?.raw;
        if (rowText === "TOTAL DES RECETTES" || rowText === "Dont TPE (Total)" || rowText === "TOTAL DES DÉPENSES" || rowText === "RÉSULTAT NET") {
           data.cell.styles.fontStyle = 'bold';
           if (rowText === "RÉSULTAT NET") {
             data.cell.styles.fillColor = [209, 250, 229];
             data.cell.styles.textColor = [5, 150, 105];
           }
        }
      }
    });
  
    doc.save("rapport_resultats.pdf");
  };


const downloadExcel = () => {
  const wsData = [
    ["Catégorie", "Valeur"],
    ["Localisation", localisation],
    ["Espéces", somme.Espece],
    ["Reduction 10%", somme.Reduction10],
    ["Réduction 20%", somme.Reduction20],
    ["Réduction TwinClub", somme.ReductionTwin],
    ["Privilége", somme.Privilege],
    ["Glovo", somme.Glovo],
    ["Ticket Resto", somme.Tresto],
    ["Tpe", somme.Tpe],
    ["Chèque", somme.Cheque],
    ["Pack Anniversaire", somme.packAnnif],
    ["Amount Total", somme.totalAmount],
    ["Dont TPE", somme.totalTpe],
    ["Expenses Total", somme.totalDailyExpenses],
    ["- Taxi", somme.taxi],
    ["- Réparation", somme.repair],
    ["- Avance Personnel", somme.advance],
    ["- Achats Divers", somme.misc],
    ["- Autres", somme.other],
    ["Net", somme.resultatnet],
  ];

  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.aoa_to_sheet(wsData);
  XLSX.utils.book_append_sheet(wb, ws, "Rapport de Résultats");

  XLSX.writeFile(wb, "rapport_resultats.xlsx");
};


  return (
    <div className="liste-rapports-twin">
      <h2>Recherche de Rapport Spintoss</h2>
      <div className="filter-form">
        <label>
          Localisation:
          <select value={localisation} onChange={(e) => setLocalisation(e.target.value)}>
            <option value="All">All</option>
            <option>Spintoss- Manar City</option>
            <option>Spintoss - Tunisia Mall</option>
            <option>Spintoss - Jardins d'eL Menzah</option>
            <option>Spintoss - Mall of Djerba</option>
          </select>
        </label>

        <label>
          Start Date:
          <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
        </label>

        <label>
          End Date:
          <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
        </label>

        <button onClick={filterData}>Confirm</button>
      </div>
    {
      recherche &&
      <div className="filtered-data">
        <h3>Résultats trouvés</h3>
        <div className="premium-table-container">
          <table className="premium-table">
            <thead>
              <tr>
                <th>MODE DE PAIEMENT / RUBRIQUE</th>
                <th>MONTANT (TND)</th>
                <th>RUBRIQUES DE DÉPENSES</th>
                <th>MONTANT (TND)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Paiements en Espèces (Direct)</td>
                <td>{somme.Espece.toFixed(3)}</td>
                <td>Frais de Taxi</td>
                <td>{somme.taxi.toFixed(3)}</td>
              </tr>
              <tr>
                <td>Ticket Resto / Glovo</td>
                <td>{(somme.Tresto + somme.Glovo).toFixed(3)}</td>
                <td>Frais de Réparation</td>
                <td>{somme.repair.toFixed(3)}</td>
              </tr>
              <tr>
                <td>Paiements TPE / Chèque</td>
                <td>{(somme.Tpe + somme.Cheque).toFixed(3)}</td>
                <td>Avance Personnel</td>
                <td>{somme.advance.toFixed(3)}</td>
              </tr>
              <tr>
                <td>Réductions Appliquées (Toutes)</td>
                <td>{(somme.Reduction10 + somme.Reduction20 + somme.ReductionTwin).toFixed(3)}</td>
                <td>Achats Divers</td>
                <td>{somme.misc.toFixed(3)}</td>
              </tr>
              <tr>
                <td>Autres (Privilège, Anniversaire)</td>
                <td>{(somme.Privilege + somme.packAnnif).toFixed(3)}</td>
                <td>Autres Dépenses</td>
                <td>{somme.other.toFixed(3)}</td>
              </tr>
              <tr className="summary-row">
                <td style={{ color: '#0ea5e9' }}>Dont Paiements par TPE (Total)</td>
                <td style={{ color: '#0ea5e9' }}>{somme.totalTpe.toFixed(3)}</td>
                <td>-</td>
                <td>-</td>
              </tr>
              <tr className="summary-total">
                <td>TOTAL DES RECETTES</td>
                <td>{somme.totalAmount.toFixed(3)}</td>
                <td>TOTAL DES DÉPENSES</td>
                <td>{somme.totalDailyExpenses.toFixed(3)}</td>
              </tr>
              <tr className="summary-net">
                <td colSpan="2">RÉSULTAT NET DE LA PÉRIODE</td>
                <td colSpan="2" className="net-value">{somme.resultatnet.toFixed(3)} TND</td>
              </tr>
            </tbody>
          </table>
        </div>

        {pieData.length > 0 && (
          <div ref={chartRef} style={{ background: '#ffffff', padding: '30px', borderRadius: '15px', marginBottom: '30px', border: '1px solid #e2e8f0', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)', width: '100%' }}>
            <h4 style={{textAlign: 'center', marginBottom: '40px', color: '#1a202c', fontWeight: 800, letterSpacing: '-0.025em'}}>Analyses Graphiques Décisives</h4>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-start', gap: '15px', flexWrap: 'nowrap', overflowX: 'auto' }}>
              
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1, minWidth: '350px' }}>
                <h5 style={{ fontSize: '14px', marginBottom: '10px', color: '#4a5568', fontWeight: 600 }}>Recettes</h5>
                <PieChart
                  series={[{ 
                    data: pieData, 
                    innerRadius: 35, 
                    outerRadius: 80, 
                    paddingAngle: 2, 
                    cornerRadius: 6,
                  }]}
                  width={350}
                  height={220}
                  slotProps={{ legend: { position: { vertical: 'middle', horizontal: 'right' }, itemMarkWidth: 8, itemMarkHeight: 8, labelStyle: { fontSize: 9 } } }}
                />
              </div>

              {pieExpensesData.length > 0 && (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1, minWidth: '350px', borderLeft: '1px solid #f1f5f9', borderRight: '1px solid #f1f5f9' }}>
                  <h5 style={{ fontSize: '14px', marginBottom: '10px', color: '#4a5568', fontWeight: 600 }}>Dépenses</h5>
                  <PieChart
                    series={[{ 
                      data: pieExpensesData, 
                      innerRadius: 35, 
                      outerRadius: 80, 
                      paddingAngle: 2, 
                      cornerRadius: 6,
                    }]}
                    width={350}
                    height={220}
                    slotProps={{ legend: { position: { vertical: 'middle', horizontal: 'right' }, itemMarkWidth: 8, itemMarkHeight: 8, labelStyle: { fontSize: 9 } } }}
                  />
                </div>
              )}

              {pieGlobalData.length > 0 && (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1, minWidth: '350px' }}>
                  <h5 style={{ fontSize: '14px', marginBottom: '10px', color: '#4a5568', fontWeight: 600 }}>Global (Net vs Exp)</h5>
                  <PieChart
                    series={[{ 
                      data: pieGlobalData, 
                      innerRadius: 35, 
                      outerRadius: 80, 
                      paddingAngle: 2, 
                      cornerRadius: 6,
                    }]}
                    width={350}
                    height={220}
                    slotProps={{ legend: { position: { vertical: 'middle', horizontal: 'right' }, itemMarkWidth: 8, itemMarkHeight: 8, labelStyle: { fontSize: 9 } } }}
                  />
                </div>
              )}

            </div>
          </div>
        )}

        <div className="actions-container">
          <Button variant="primary" onClick={downloadPDF}>
            Télécharger en PDF
          </Button>
          <Button variant="success" onClick={downloadExcel}>
            Télécharger en Excel
          </Button>
        </div>

        {filteredData.length > 0 ? (
          <div className="rapports-grid">
            {filteredData.map((el, i) => (
              <CardRapportSpintoss key={i} el={el} />
            ))}
          </div>
        ) : (
          <p>Aucun résultat trouvé</p>
        )}
      </div>
    }
    </div>

    // <div>
      
    //   <div>
    //     {
    //       rapports.map((el,i,t)=> <CardRapportSpintoss el={el}/>)
    //     }
    //   </div>
    // </div>
  );
}

export default ListRapportsSpintoss;
